import React, {useState} from 'react';
import { InfoBox, OtherCard } from 'components';
import LabelUnvan from 'assests/icons/unvan-label.icon';

import {  Button,Modal } from 'antd';

import { useHistory } from 'react-router-dom';
const TitleCard = () =>
{
  var history=useHistory();
  return (
    <React.Fragment>
      <OtherCard
        v3
        content={<>
          <span className="other-card__title">Şirket Ünvanınızı Kaydedin</span>
          <p>Şirket ünvanlarınızı (Mesaj Başlıklarını) şimdi ekleyebilir, mesaj oluştururken dilediğiniz ünvanı kolayca seçebilirsiniz.</p>
          <div className="other-card__buttons">

            <Button
              type="primary"
              shape="round"
              onClick={(e) => history.push("/Title")}
            >
              Ünvan İşlemleri
            </Button>
          </div>
        </>}
        actions={
        <>
          <LabelUnvan  />
        </>
        }
      />
      
    </React.Fragment>
  );
};

export default TitleCard;
